import {
  useAddProductToBasket,
  useDeleteProductBasket,
  useGetCurrentBasket,
} from '@api/basket/basketApis.rq';
import Icon from '@utilities/icon';
import { useMemo } from 'react';
import SpinnerQuantity from './spinnerQuantity';
import { motion } from 'framer-motion';
import classNames from 'classnames';

const Counter = ({ product }) => {
  const {
    data: basket,
    refetch: refetchGetBasket,
    isRefetching,
  } = useGetCurrentBasket();

  const { mutate: addToCart, isPending: isAddingToCart } =
    useAddProductToBasket({
      onSuccess: () => {
        refetchGetBasket();
      },
    });

  const { mutate: deleteFromCart, isPending: isPendingDeleteFromCart } =
    useDeleteProductBasket({
      onSuccess: () => {
        refetchGetBasket();
      },
    });

  const productBasketQuantity =
    basket?.products?.find(
      (basketItem) =>
        basketItem?.irc === (product?.irc || product?.genericCode),
    )?.quantity ?? 0;

  const onChangeCountFromBasket = (count) => {
    addToCart({
      ...product,
      quantity: count,
    });
    return;
  };

  const onChangePlus = (e) => {
    e.stopPropagation();
    const rise = productBasketQuantity + 1;
    onChangeCountFromBasket(rise);
    return;
  };
  const onChangeMinus = (e) => {
    e.stopPropagation();

    if (productBasketQuantity === 0) return;

    if (productBasketQuantity <= 1) {
      deleteFromCart({
        type: 'IRC',
        irc: product?.irc || product?.genericCode,
      });
      return;
    }
    const minus = productBasketQuantity - 1;
    onChangeCountFromBasket(minus);
    return;
  };

  const isLoading = isAddingToCart || isPendingDeleteFromCart;

  const elements = useMemo(() => {
    if (productBasketQuantity < 1 && isLoading)
      return (
        <div className="h-8 w-8 flex justify-center items-center">
          <SpinnerQuantity />
        </div>
      );
    if (productBasketQuantity < 1 && !isLoading)
      return (
        <button
          onClick={onChangePlus}
          className="flex items-center justify-center h-8 w-8 bg-white rounded-full"
          aria-label="Add to basket"
        >
          <Icon name="Plus" width={1.25} height={1.25} fill={'black'} />
        </button>
      );

    if (productBasketQuantity >= 1) {
      return (
        <>
          <button
            onClick={onChangePlus}
            disabled={isLoading}
            className="flex items-center justify-center h-8 w-8 bg-white rounded-full disabled:opacity-50"
          >
            <Icon name="Plus" width={1.25} height={1.25} fill={'black'} />
          </button>
          {productBasketQuantity > 0 && !isLoading && (
            <div
              className={classNames(
                !product?.unit && 'justify-center',
                'flex min-w-8 text-center gap-1 text-xs',
              )}
            >
              <span>{productBasketQuantity}</span>
              {product?.unit && (
                <span className="text-xs ml-1">{product?.unit}</span>
              )}
            </div>
          )}
          {isLoading && (
            <div className="flex justify-center items-center min-w-8 text-center gap-1 text-xs h-8 w-9">
              <SpinnerQuantity />
            </div>
          )}
          {productBasketQuantity > 1 && (
            <button
              onClick={onChangeMinus}
              disabled={isLoading}
              className="flex items-center justify-center h-8 w-8 bg-white rounded-full disabled:opacity-50"
            >
              <Icon name="Minus" width={1.25} height={1.25} fill={'black'} />
            </button>
          )}
          {productBasketQuantity === 1 && (
            <button
              onClick={onChangeMinus}
              disabled={isLoading}
              className="flex items-center justify-center h-8 w-8 bg-white rounded-full disabled:opacity-50"
            >
              <Icon name="Trash" width={1.25} height={1.25} fill={'black'} />
            </button>
          )}
        </>
      );
    }
  }, [isLoading, productBasketQuantity]);
  return (
    <div className="flex justify-center items-center absolute bottom-1 right-1.5 z-[2] pointer-events-auto bg-white rounded-full shadow-lg transition-all">
      {elements}
    </div>
  );
};

export default Counter;
